import { usePostHog } from 'posthog-js/react';
import { trackEvent as telemetryTrackEvent } from '@utils/analytics/telemetry';
import { TRACK_ERROR_NAMES, TRACK_EVENT_NAMES } from '@utils/analytics/events';

// Re-export para no romper los imports existentes (`import useTracking, { TRACK_EVENT_NAMES } ...`).
export { TRACK_EVENT_NAMES, TRACK_ERROR_NAMES };

type EventData = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

const getLoginData = () => {
  return {
    commerceId: localStorage.getItem('id_commerce'),
    id: localStorage.getItem('id_user'),
    pathId: localStorage.getItem('id_path'),
    commerceName: localStorage.getItem('commerce_name'),
    commerceLogo: localStorage.getItem('commerce_logo'),
    userName: localStorage.getItem('user_name'),
    userPermissions: localStorage.getItem('user_permissions'),
    userData: localStorage.getItem('userData') ?? '',
  };
};

const defaultEventData = () => {
  const loginData = getLoginData();
  const user = loginData.userData ? JSON.parse(loginData.userData) : null;

  return {
    ...loginData,
    ...(user && {
      user: {
        id: user.id,
        email: user.email,
        name: user.name,
        status: user.status,
        username: user.username,
      },
    }),
  };
};

const useTracking = () => {
  const posthog = usePostHog();

  // El pageview se centralizó en usePageView (montado en cada Layout) para no
  // multiplicarse por cada componente que usa useTracking. La captura del session id
  // de telemetría vive en AuthContext.

  const trackEvent = (eventName: string, eventData?: EventData) => {
    const defaultData = defaultEventData();
    const data = {
      ...defaultData,
      ...eventData,
    };

    if (defaultData.user) {
      data.distinct_id = defaultData.commerceName;
      data.id_commerce = defaultData.commerceId;
      data.userId = defaultData.user.id;
      data.userEmail = defaultData.user.email;
      data.userName = defaultData.user.username;
    }

    // Fan-out a PostHog (payload completo) + Clarity (evento + upgrade) + GA4 (snake_case, sin PII).
    telemetryTrackEvent(posthog, eventName, data);
  };

  return {
    trackEvent,
  };
};

export default useTracking;
